import moment from 'moment';

export const monthNames = [
    'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
    'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
];

export function formatSummaInput(value) {
    if (value == null || value === '') return '';
    const n = Number(String(value).replace(/\s/g, '').replace(',', '.'));
    if (Number.isNaN(n)) return '';
    return String(Math.round(n));
}

export function dateInputValue(value) {
    if (!value) return '';
    const str = String(value).trim();
    const dmy = str.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
    if (dmy) return `${dmy[3]}-${dmy[2]}-${dmy[1]}`;
    const d = moment(value);
    if (d.isValid()) return d.format('YYYY-MM-DD');
    return '';
}

export const toArray = (data) => {
    if (!data) return [];
    return Array.isArray(data) ? data : [data];
};

export function groupAnalitiki(rows) {
    const seenKod = new Set();
    const items = [];
    for (const item of toArray(rows)) {
        const kod = item?.kod == null ? '' : String(item.kod);
        if (kod && seenKod.has(kod)) continue;
        if (kod) seenKod.add(kod);
        const tip = Number(item?.tip);
        items.push({
            id: item?.id,
            kod,
            name: item?.name,
            tip: Number.isFinite(tip) ? tip : Number.MAX_SAFE_INTEGER,
            tipText: String(item?.tipText ?? '').trim() || 'Без типа',
        });
    }

    items.sort((a, b) => {
        if (a.tip !== b.tip) return a.tip - b.tip;
        return String(a.kod ?? '').localeCompare(String(b.kod ?? ''), 'ru', { numeric: true });
    });

    const groups = [];
    for (const item of items) {
        const last = groups[groups.length - 1];
        if (last && last.tip === item.tip) {
            last.items.push(item);
        } else {
            groups.push({ tip: item.tip, label: `Тип: ${item.tipText}`, items: [item] });
        }
    }
    return groups;
}

export const sqlEsc = (s) => String(s ?? '').replace(/'/g, "''");

export function toLocalISODate(date, endOfDay = false) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}T${endOfDay ? '23:59:59' : '00:00:00'}`;
}

export function toSqlDateTime(value) {
    if (!value) return new Date().toISOString();
    if (typeof value === 'string' && value.trim()) {
        return value.trim().replace(' ', 'T');
    }
    if (value instanceof Date && !isNaN(value.getTime())) return value.toISOString();
    const d = new Date(value);
    if (!isNaN(d.getTime())) return d.toISOString();
    return new Date().toISOString();
}

export function getPeriodList(monthsAhead = 5, extraKod = '') {
    const now = new Date();
    const startYear = now.getFullYear();
    const startMonth = now.getMonth();

    const list = [];
    for (let i = -1; i <= monthsAhead; i++) {
        const date = new Date(startYear, startMonth + i, 1);
        const year = date.getFullYear();
        const month = date.getMonth();
        list.push({
            kod: `${year}-${String(month + 1).padStart(2, '0')}`,
            name: `${monthNames[month]} ${year}`
        });
    }

    if (extraKod && !list.some((item) => item.kod === extraKod)) {
        const [year, month] = extraKod.split('-').map(Number);
        if (year && month >= 1 && month <= 12) {
            list.unshift({
                kod: extraKod,
                name: `${monthNames[month - 1]} ${year}`
            });
        }
    }

    return list;
}

export function periodKodFromDate(value) {
    if (!value) return '';
    const d = moment(value);
    if (!d.isValid()) return '';
    return `${d.year()}-${String(d.month() + 1).padStart(2, '0')}`;
}

export function periodKodFromLabel(label) {
    const m = String(label ?? '').trim().match(/^(\S+)\s+(\d{4})$/);
    if (!m) return '';
    const monthIdx = monthNames.findIndex((n) => n.toLowerCase() === m[1].toLowerCase());
    if (monthIdx < 0) return '';
    return `${m[2]}-${String(monthIdx + 1).padStart(2, '0')}`;
}

export function periodRange(periodKod) {
    const [periodYear, periodMonth] = String(periodKod || '').split('-').map(Number);
    const firstDayOfMonth = new Date(periodYear, periodMonth - 1, 1);
    const lastDayOfMonth = new Date(periodYear, periodMonth, 0);
    const periodLabel = monthNames[periodMonth - 1]
        ? `${monthNames[periodMonth - 1]} ${periodYear}`
        : '';
    return { firstDayOfMonth, lastDayOfMonth, periodLabel };
}

export function parseFileNames(files) {
    if (files == null || files === '') return [];
    const str = String(files).trim();
    if (!str) return [];

    let parts = str.split(/[;\n|]+/).map((s) => s.trim()).filter(Boolean);
    if (parts.length <= 1 && str.includes(',')) {
        const byComma = str.split(',').map((s) => s.trim()).filter(Boolean);
        if (byComma.length > 1) parts = byComma;
    }
    return parts;
}

export function parseKomment(komment) {
    const str = String(komment ?? '');
    const take = (re) => {
        const m = str.match(re);
        return m ? m[1].trim() : '';
    };

    const vBudjetRaw = take(/В бюджете:\s*([^|]+)/);
    const vBudjet = vBudjetRaw === '-' ? '' : vBudjetRaw;
    const fioSamozan = take(/ФИО самозанятого:\s*([^|]+)/);
    const poluchatel = take(/Получатель:\s*([^|]+)/);
    const periodLabel = take(/Период:\s*([^|]+)/);
    const vidOplatyRaw = take(/Вид оплаты:\s*([^|]+)/);
    const vidOplaty = ['Наличные', 'Безналичные'].includes(vidOplatyRaw) ? vidOplatyRaw : '';
    const deadlineRaw = take(/Оплатить:\s*([^|]+)/);

    let problem = str
        .replace(/\s*\|\s*В бюджете:\s*[^|]*/g, '')
        .replace(/\s*\|\s*ФИО самозанятого:\s*[^|]*/g, '')
        .replace(/\s*\|\s*Получатель:\s*[^|]*/g, '')
        .replace(/\s*\|\s*Период:\s*[^|]*/g, '')
        .replace(/\s*\|\s*Вид оплаты:\s*[^|]*/g, '')
        .replace(/\s*\|\s*Оплатить:\s*[^|]*/g, '')
        .replace(/^В бюджете:\s*[^|]*/g, '')
        .replace(/^ФИО самозанятого:\s*[^|]*/g, '')
        .replace(/^Получатель:\s*[^|]*/g, '')
        .replace(/^Период:\s*[^|]*/g, '')
        .replace(/^Вид оплаты:\s*[^|]*/g, '')
        .replace(/^Оплатить:\s*[^|]*/g, '')
        .replace(/^\s*\|\s*/, '')
        .replace(/\s*\|\s*$/, '')
        .trim();

    return {
        problem,
        vBudjet,
        fioSamozan,
        poluchatel,
        periodLabel,
        periodKod: periodKodFromLabel(periodLabel),
        vidOplaty,
        deadline: dateInputValue(deadlineRaw),
    };
}

export function buildKomment({ problem, vBudjet, poluchatel, fioSamozan, periodLabel, vidOplaty, deadline }) {
    const deadlineLabel = deadline ? moment(deadline).format('DD.MM.YYYY') : '';
    return [
        (problem ?? '').trim(),
        `В бюджете: ${vBudjet ?? '-'}`,
        poluchatel === 'Самозанятый' ? `ФИО самозанятого: ${fioSamozan}` : '',
        `Получатель: ${poluchatel}`,
        vidOplaty ? `Вид оплаты: ${vidOplaty}` : '',
        deadlineLabel ? `Оплатить: ${deadlineLabel}` : '',
        `Период: ${periodLabel}`,
    ].filter(Boolean).join(' | ');
}

function numOr(value, fallback) {
    if (value == null || value === '') return fallback;
    const n = +value;
    return Number.isNaN(n) ? fallback : n;
}

export function buildFinDvigValues(form, extras = {}) {
    const { firstDayOfMonth, lastDayOfMonth, periodLabel } = periodRange(form.period);
    const komment = buildKomment({
        problem: form.problem,
        vBudjet: form.vBudjet,
        poluchatel: form.poluchatel,
        fioSamozan: form.fioSamozan,
        periodLabel,
        vidOplaty: form.vidOplaty,
        deadline: form.deadline,
    });
    const summa = +formatSummaInput(form.summa) || 0;
    const dataFromDeadline = form.deadline
        ? (String(form.deadline).length === 10 ? `${form.deadline}T00:00:00` : form.deadline)
        : null;

    return {
        userID: extras.userID,
        nomDoc: numOr(extras.nomDoc, 0),
        nomDocStr: extras.nomDocStr ?? '',
        operation: numOr(extras.operation, 5),
        summa,
        summaAll: summa,
        sebestoim: summa,
        nds: numOr(extras.nds, 0),
        urlico: numOr(form.urlico, numOr(extras.urlico, 1)),
        mestoDS: numOr(extras.mestoDS, 0),
        data: dataFromDeadline ?? extras.data ?? new Date(),
        dataS: firstDayOfMonth,
        dataPo: lastDayOfMonth,
        kontr: +form.idKontr || 55,
        kontrINN: extras.kontrINN ?? '0000000000',
        idKontakt: numOr(form.selectedKontakt?.idKontakt ?? extras.idKontakt, -1),
        exp: form.analitik ?? '',
        shema: numOr(extras.shema, 0),
        dep: form.depart ?? '',
        city: extras.city ?? '',
        proekt: form.tipTask ?? '',
        sotr: numOr(form.sotrId, 0),
        komment,
        tip: numOr(extras.tip, 1),
        nomDocOsn: numOr(extras.nomDocOsn, 0),
        vidDocOsn: numOr(extras.vidDocOsn, 0),
        so: extras.so ?? '',
        po: extras.po ?? '',
        valuta: extras.valuta ?? 'RUB',
        kurs: extras.kurs ?? 1,
        kursDate: extras.kursDate ?? extras.data ?? new Date(),
        nomSchet: extras.nomSchet ?? '',
        dateSchet: extras.dateSchet ?? extras.data ?? new Date(),
        initiat: numOr(form.selectedManagers?.[0]?.id ?? extras.initiat, 0),
        rabotaSub: extras.rabotaSub ?? -1,
        files: form.rekvizityString ?? '',
    };
}

export function formatAddFinDvigQuery(v) {
    return `
                EXEC addFinDvig
                    @userID = ${+v.userID},
                    @nomDocStr = '${sqlEsc(v.nomDocStr)}',
                    @summa = ${+v.summa || 0},
                    @nds = ${+v.nds || 0},
                    @sebestoim = ${+v.sebestoim || 0},
                    @urlico = ${+v.urlico || 0},
                    @mestoDS = ${+v.mestoDS || 0},
                    @data = '${toSqlDateTime(v.data)}',
                    @dataS = '${toLocalISODate(v.dataS)}',
                    @dataPo = '${toLocalISODate(v.dataPo, true)}',
                    @kontr =   ${+v.kontr || 55},
                    @kontrINN = '${sqlEsc(v.kontrINN)}',
                    @idKontakt = ${+v.idKontakt},
                    @exp = '${sqlEsc(v.exp)}',
                    @shema = ${+v.shema || 0},
                    @dep = ${sqlEsc(v.dep)},
                    @proekt = '${sqlEsc(v.proekt)}',
                    @sotr = ${+v.sotr},
                    @komment = '${sqlEsc(v.komment)}',
                    @tip = ${+v.tip},
                    @nomDocOsn = ${+v.nomDocOsn},
                    @vidDocOsn = ${+v.vidDocOsn},
                    @valuta = '${sqlEsc(v.valuta)}',
                    @kurs = ${+v.kurs},
                    @kursDate = '${toSqlDateTime(v.kursDate)}',
                    @nomSchet = '${sqlEsc(v.nomSchet)}',
                    @dateSchet = '${toSqlDateTime(v.dateSchet)}',
                    @initiat = ${+v.initiat},
                    @rabotaSub = ${+v.rabotaSub},
                    @files = '${sqlEsc(v.files)}',
                    @so = '${sqlEsc(v.so)}',
                    @po = '${sqlEsc(v.po)}',
                    @city= '${sqlEsc(v.city)}',
                    @nomDoc = ${+v.nomDoc || 0},
                    @operation = ${+v.operation || 5}
            `;
}

export function formatEditFinDvigQuery(v) {
    return `
                EXEC editFinDvig
                    @nomDoc = ${+v.nomDoc},
                    @operation = ${+v.operation || 5},
                    @nomDocStr = '${sqlEsc(v.nomDocStr)}',
                    @summaAll = ${+v.summaAll || 0},
                    @summa = ${+v.summa || 0},
                    @sebestoim = ${+v.sebestoim || 0},
                    @mestoDS = ${+v.mestoDS || 0},
                    @urlico = ${+v.urlico || 0},
                    @data = '${toSqlDateTime(v.data)}',
                    @dataS = '${toLocalISODate(v.dataS)}',
                    @dataPo = '${toLocalISODate(v.dataPo, true)}',
                    @kontr = ${+v.kontr || 55},
                    @kontrINN = '${sqlEsc(v.kontrINN)}',
                    @idKontakt = ${+v.idKontakt},
                    @exp = '${sqlEsc(v.exp)}',
                    @shema = ${+v.shema || 0},
                    @dep = '${sqlEsc(v.dep)}',
                    @city = '${sqlEsc(v.city)}',
                    @proekt = '${sqlEsc(v.proekt)}',
                    @sotr = ${+v.sotr},
                    @komment = '${sqlEsc(v.komment)}',
                    @tip = ${+v.tip},
                    @nomDocOsn = ${+v.nomDocOsn},
                    @vidDocOsn = ${+v.vidDocOsn},
                    @so = '${sqlEsc(v.so)}',
                    @po = '${sqlEsc(v.po)}',
                    @valuta = '${sqlEsc(v.valuta)}',
                    @kurs = ${+v.kurs},
                    @kursDate = '${toSqlDateTime(v.kursDate)}',
                    @nds = ${+v.nds || 0},
                    @nomSchet = '${sqlEsc(v.nomSchet)}',
                    @dateSchet = '${toSqlDateTime(v.dateSchet)}',
                    @initiat = ${+v.initiat},
                    @rabotaSub = ${+v.rabotaSub},
                    @files = '${sqlEsc(v.files)}'
            `;
}

const orderKey = (item) => String(item?.nomer ?? item?.nomDoc ?? '');

export async function fetchFinOrder(network, userId, id) {
    if (id == null || id === '' || id === 'undefined' || id === 'null') return null;

    const date1 = moment().subtract(1, 'year').format('YYYY-MM-DD');
    const date2 = moment().add(1, 'days').format('YYYY-MM-DD');

    const [planRaw, oplatRaw] = await Promise.all([
        network.getPlanListRange(+userId),
        network.getPayListRange(+userId, date1, date2),
    ]);

    const list = [...toArray(planRaw), ...toArray(oplatRaw)];
    return list.find((item) => orderKey(item) === String(id)) ?? null;
}

function resolveFromList(list, raw, kodKey, nameKey) {
    if (raw == null || raw === '') return '';
    const asStr = String(raw);
    const byKod = list.find((item) => String(item[kodKey]) === asStr);
    if (byKod) return String(byKod[kodKey]);
    const byName = list.find((item) => String(item[nameKey] ?? '').trim().toLowerCase() === asStr.trim().toLowerCase());
    if (byName) return String(byName[kodKey]);
    const byKodName = list.find((item) => `${item[kodKey]} - ${item[nameKey]}` === asStr);
    if (byKodName) return String(byKodName[kodKey]);
    return asStr;
}

export function orderToForm(row, { managerList = [], clientList = [], analitikList = [], departList = [], projectsList = [] } = {}) {
    const parsed = parseKomment(row?.komment);
    const period = periodKodFromDate(row?.dataS) || parsed.periodKod || '';

    const initiatId = +(row?.initiat ?? row?.initiatId ?? 0);
    const initiatName = (row?.initiatName || '').trim();
    let selectedManagers = [];
    if (initiatId) {
        const found = managerList.find((m) => +m.id === initiatId);
        selectedManagers = found
            ? [{ id: found.id, name: found.name || found.fio }]
            : [{ id: initiatId, name: initiatName || String(initiatId) }];
    } else if (initiatName) {
        const found = managerList.find((m) => (m.name || m.fio || '').trim().toLowerCase() === initiatName.toLowerCase());
        if (found) selectedManagers = [{ id: found.id, name: found.name || found.fio }];
    }

    let fioSamozan = parsed.fioSamozan;
    const sotrId = +(row?.sotr ?? 0);
    if (!fioSamozan && sotrId) {
        const found = managerList.find((m) => +m.id === sotrId);
        if (found) fioSamozan = found.fio || found.name || '';
    }

    const kontrRaw = row?.kontr ?? row?.idKontr ?? row?.idUrllico;
    let idKontr = +(kontrRaw ?? 0) || 0;
    if (!idKontr) {
        const kontrName = (row?.kontrName || row?.kontrUrName || '').trim().toLowerCase();
        if (kontrName) {
            const found = clientList.find((c) => (c.name || '').trim().toLowerCase() === kontrName);
            if (found) idKontr = +found.idUrllico;
        }
    }

    const idKontakt = +(row?.idKontakt ?? 0);
    const selectedKontakt = idKontakt > 0 ? { idKontakt } : null;

    const analitik = resolveFromList(analitikList, row?.exp || row?.exp2 || '', 'kod', 'name');
    const depart = resolveFromList(departList, row?.dep || '', 'kod', 'name');
    const tipTask = resolveProject(projectsList, row?.proekt || row?.proektName || '');

    return {
        problem: parsed.problem,
        vBudjet: parsed.vBudjet,
        poluchatel: parsed.poluchatel,
        fioSamozan,
        period,
        summa: formatSummaInput(row?.summa),
        tipTask,
        analitik,
        depart,
        urlico: row?.urlico != null && row?.urlico !== '' ? String(row.urlico) : '',
        idKontr: idKontr || 55,
        selectedManagers,
        selectedKontakt,
        uploadedFileNames: parseFileNames(row?.files),
        vidOplaty: parsed.vidOplaty,
        deadline: parsed.deadline || dateInputValue(row?.dataDo || row?.dataOplaty || row?.data),
        extras: {
            nomDoc: row?.nomDoc ?? row?.nomer,
            nomDocStr: row?.nomDocStr ?? '',
            urlico: row?.urlico,
            mestoDS: row?.mestoDS,
            data: row?.data,
            kontrINN: row?.kontrINN,
            idKontakt: idKontakt > 0 ? idKontakt : -1,
            shema: row?.shema,
            city: row?.city,
            nomDocOsn: row?.nomDocOsn,
            vidDocOsn: row?.vidDocOsn,
            so: row?.so,
            po: row?.po,
            valuta: row?.valuta,
            kurs: row?.kurs,
            nds: row?.nds,
            nomSchet: row?.nomSchet,
            dateSchet: row?.dateSchet,
            rabotaSub: row?.rabotaSub,
            kursDate: row?.kursDate ?? row?.data,
            operation: 5,
            tip: row?.tip ?? 1,
        },
    };
}

function resolveProject(list, raw) {
    if (raw == null || raw === '') return '';
    const asStr = String(raw).trim();
    const found = list.find((item) => {
        const kod = item?.kod != null ? String(item.kod) : '';
        const id = item?.id != null ? String(item.id) : '';
        const name = String(item?.name ?? '').trim().toLowerCase();
        return kod === asStr || id === asStr || (name && name === asStr.toLowerCase());
    });
    if (!found) return asStr;
    return found.kod != null && found.kod !== '' ? String(found.kod) : String(found.id ?? asStr);
}
